import React, { useEffect, useState } from 'react';
import { IBarChartCard } from './BarChartCard.interface';
import styles from './BarChartCard.module.scss';
import { BarChart } from '../BarChart/BarChart';
import { Globe } from '@zurich-data-dsm-icons/communication.globe';
import { IMonthlyUsageDetail } from 'pages/Costs';

export const BarChartCard: React.FC<IBarChartCard> = ({ usageData }) => {
  const [chartData, setChartData] = useState<any[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [chartLegend, setChartLegend] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    const groupedByMonthNameData = renameKeyToMonthName(usageData);
    const formattedData = formatGroupedData(groupedByMonthNameData);
    extractKeys(formattedData);
    setChartData(formattedData);
  }, [usageData]);

  useEffect(() => {
    if (chartKeys.length > 0) {
      const legend = createLegend(chartKeys);
      setChartLegend(legend);
    }
  }, [chartKeys]);

  const getMonthName = (month: number): string => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    return months[month - 1];
  };

  const renameKeyToMonthName = (groupedData: {
    [key: string]: any;
  }): { [key: string]: any } => {
    const groupedDataWithMonthName: { [key: string]: any } = {};

    for (const month in groupedData) {
      const monthName = getMonthName(parseInt(month));
      groupedDataWithMonthName[monthName] = groupedData[month];
    }
    console.log(groupedDataWithMonthName);
    return groupedDataWithMonthName;
  };

  const formatGroupedData = (data: {
    [key: string]: IMonthlyUsageDetail;
  }): any[] => {
    const formattedData = [];
    for (const month in data) {
      const usageItem: { [key: string]: number | string } = { id: month };
      for (const productName in data[month].services) {
        usageItem[productName] = data[month].services[productName];
      }
      formattedData.push(usageItem);
    }
    console.log('processed', formattedData);
    return formattedData;
  };

  const extractKeys = (chartData: any[]): void => {
    const keys = new Set();
    chartData.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key !== 'id') {
          keys.add(key);
        }
      });
    });
    setChartKeys(Array.from(keys));
  };

  const createLegend = (keys: string[]): { [key: string]: string } => {
    const legend: { [key: string]: string } = {};
    keys.forEach((key) => {
      legend[key] = key.length > 10 ? key.slice(0, 10) + '...' : key;
    });
    return legend;
  };

  return (
    <div className={styles['chart-container']}>
      <div className={styles['chart-header']}>
        <div className={styles['chart-legend']}>
          <Globe />
          <p>Types of services</p>
        </div>
      </div>
      {chartData && chartKeys && chartLegend && (
        <BarChart
          width="100%"
          height="70vh"
          colorPalette="divergent"
          data={chartData}
          keys={chartKeys}
          legend={{
            leftAxis: 'Number of Calls',
            bottomAxis: 'Month',
            labels: chartLegend
          }}
        />
      )}
    </div>
  );
};
